import { connect } from 'react-redux'
import { selectors as backendSelectors } from '../../features/Backend'
import { selectors as settingsSelectors } from '../../features/Settings'
import { selectors as usersSelectors } from '../../features/Users'
import Dashboard from '../../components/Dashboard'
import localizeImport from '../../store/localize'
import getAttributes from '../../settings/attributes'
import strings from '../../components/Dashboard/Dashboard.json'
import { actionAppSetShowLoginState, actionAppSetAutoLaunchEnabledState } from '../../actions'
import logo from '../../logo-large.zh.png'

function mapStateToProps(state, ownProps) {
    const { app } = state
    const userCount = usersSelectors.getActiveLoggedInUserIds(state).length
    const tokensHash = usersSelectors.getTokenHash(state)
    const locale = backendSelectors.getLocale(state)
    const attributes = getAttributes(locale)

    const localize = value => localizeImport(strings, locale, value)

    return {
        autoRunEnabled: app.autoRunEnabled,
        readyForDisplay: settingsSelectors.areUiSettingsLoaded(state),
        showLogin: app.showLogin,
        userCount,
        tokensHash,
        ssoStatus: attributes.service.sso.status,
        locale,
        logo: locale === 'zh' ? logo : undefined,
        offlineTexts: {
            header: localize('offlineHeader'),
            message: localize('offlineMessage'),
            retry: localize('offlineRetry'),
        },
        loadingText: localize('loading'),
        layout: ownProps.layout,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setLoginShowState: (showLogin) => {
            dispatch(actionAppSetShowLoginState(showLogin))
        },
        disableAutoRun: () => {
            dispatch(actionAppSetAutoLaunchEnabledState(false))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js